import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as endpoints from "../../api/endpoints"
import ReactHtmlParser from "react-html-parser"
import { isMobile } from "react-device-detect"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import Svg from "../_svgs/svg"
import SearchOverlay from "../flight-search-hero/search-overlay"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as cookieHelper from "../../helpers/cookie"
import { DateTime } from "luxon"
import { handleClickTracking } from "../../helpers/tracking"

export default class AirlinePage extends Component {
  constructor(props) {
    super(props)

    const dtLocale = dateHelper.luxonLocale(props.locale)
    const zone = "Europe/Copenhagen"
    const cphTimeConvert = DateTime.local().setLocale(dtLocale).setZone(zone) // gets local time and changes timezone to copenhagen to get correct time
    const cphTime = cphTimeConvert.setZone("local", { keepLocalTime: true }) // locks in copenhagen time and switches back to local timezone. This ensures the time will stay CPH time when we later converts the DateTime to a JS Date object.
    let startDate = cphTime.set({ milliseconds: 0, seconds: 0, minutes: 60 }).minus({ hours: 1 })
    let minDate = startDate.minus({ days: 1 })
    let minTime = cphTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    let maxTime = cphTime.set({ hours: 23, minutes: 0, seconds: 0, milliseconds: 0 })

    this.state = {
      flights: [],
      direction: "D",
      q: "",
      showOverlay: false,
      searchDate: startDate,
      minDate: minDate,
      datepickerOpen: false,
      minTime: minTime,
      maxTime: maxTime,
      otherDaysMinTime: minTime,
      airports: [],
      airlines: [],
      mobileInputFocus: false,
      startDate: startDate,
    }
  }

  componentDidMount() {
    this.addEventListeners()
  }

  addEventListeners() {
    document.body.addEventListener("keydown", (e) => {
      let flightId = document.getElementById("flight-search-hero-input")
      let flightIsFocused = document.activeElement === flightId
      if (e.key === "Escape") {
        this.setState({ showOverlay: false })
        if (isMobile) {
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = null
          }
          this.setZIndexOfNotificationBanner(null)
        }
        const input = document.querySelector("#flight-search-hero-input")
        if (input) {
          input.blur()
        }
      }
      if (e.key === "Enter" && flightIsFocused) {
        window.location.href = `${this.state.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage}?q=${
          this.state.q
        }&date=${this.state.searchDate.toFormat("dd / MM / yyyy")}&time=${this.state.searchDate.toFormat("HH")}`
      }
    })
  }

  search = async () => {
    if (this.state.q.length >= (this.props.minCharsBeforeSearch ?? 2)) {
      const dt = this.state.searchDate
      const zone = "Europe/Copenhagen"
      const cphTime = dt.setZone(zone, { keepLocalTime: true }) // set zone to copenhagen and keep local time, which is already cph time
      const start = cphTime.toUTC() // convert to UTC which is what Solr expects
      const end = cphTime.endOf("day").toUTC() // convert to UTC which is what Solr expects
      const flightsData = {
        direction: this.state.direction,
        query: this.state.q,
        startDateTime: start,
        endDateTime: end,
        language: this.props.locale,
      }

      // use this data and call GetAirports endpoint to get airports from solr core instead of flightinfo
      // const airportsData = { language: this.props.locale, query: this.state.q, limit: this.props.allFlightsLimit }
      const returns = await Promise.all([this.getFlights(flightsData), this.getAirports(flightsData)])
        .then((responses) => {
          return Promise.all(
            responses.map((response) => {
              return response
            }),
          )
        })
        .then((data) => {
          return data
        })
        .catch((err) => {
          console.log(err)
        })
      const flights = returns[0]
      const airports = returns[1]
      const airlines = this.getAirlines(flights)
      this.setState({ flights: flights, airports: airports, airlines: airlines })
    }
  }

  getFlights = (data) => {
    return endpoints
      .getFlightInfoTable(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let flights = []
        if (data) {
          flights = data
        }
        return flights
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getAirports = (data) => {
    // return endpoints.getAirports(data)
    return endpoints
      .getAirportsFromFlights(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let airports = []
        if (data) {
          airports = data
        }
        return airports
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getAirlines = (flights) => {
    let airlines = []
    if (flights && flights.length > 0) {
      const result = Array.from(new Set(flights.map((f) => f.IataAirline))).map((iata) => {
        return {
          iata: iata,
          name: flights.find((f) => f.IataAirline === iata).Airline,
          nameMobile: flights.find((f) => f.IataAirline === iata).AirlineMobile,
        }
      })
      airlines = result
    }
    return airlines
  }

  handleInput = (event, search = true) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (this.state.q.length >= 1) {
          if (isMobile && !this.state.showOverlay) {
            // scroll to top to fix the input field in the overlay being out of view on iphone
            window.scrollTo(0, 0)
            this.setZIndexOfNotificationBanner(0)
          }
          this.setState({ showOverlay: true }, () => {
            if (search) this.search()
            if (isMobile) {
              const elements = document.getElementsByClassName("site-header")
              const siteHeader = elements[0]
              if (siteHeader) {
                siteHeader.style.display = "none"
              }
            }
          })
        } else {
          if (!isMobile) {
            this.handleCloseOverlay()
          }
        }
      },
    )
  }

  handleDirectionChange = (direction, wasFocused) => {
    if (isMobile) {
      const input = document.getElementById("flight-search-hero-input")
      if (input && wasFocused) {
        input.focus()
        setTimeout(() => {
          this.setState({ mobileInputFocus: true })
        }, 20)
      }
    }
    this.setState({ direction: direction }, () => {
      this.search()
    })
  }

  handleCloseOverlay = () => {
    this.setState({ showOverlay: false, searchDate: this.state.startDate, q: "", flights: [], airports: [] }, () => {
      if (isMobile) {
        const elements = document.getElementsByClassName("site-header")
        const siteHeader = elements[0]
        if (siteHeader) {
          siteHeader.style.display = null
        }
        this.setZIndexOfNotificationBanner(null)
      }
    })
  }

  handleDateChange = (dateInput) => {
    this.setState(
      (prevState) => {
        let dateTime = DateTime.fromJSDate(dateInput)
        const startOfPrevDate = prevState.searchDate.startOf("day")
        const startOfMinDate = prevState.minDate.startOf("day")
        const startOfNewDate = dateTime.startOf("day")
        if (startOfMinDate.toMillis() === startOfNewDate.toMillis()) {
          // if the times are the same, meaning only the date was changed, set date to minDate
          const time = dateTime.toFormat("HH:mm")
          const prevTime = prevState.searchDate.toFormat("HH:mm")
          if (dateTime <= prevState.minDate || time === prevTime) {
            return { searchDate: prevState.minDate, minTime: prevState.minDate }
          }
          return { searchDate: dateTime, minTime: prevState.minDate }
        } else {
          // if the dates have changed, set time to 0
          if (startOfPrevDate.toMillis() !== startOfNewDate.toMillis()) dateTime = dateTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
          return { searchDate: dateTime, minTime: prevState.otherDaysMinTime }
        }
      },
      () => this.search(),
    )
  }

  handleDatepicker = () => {
    this.setState({ datepickerOpen: !this.state.datepickerOpen })
  }

  closeDatepicker = () => {
    this.setState({ datepickerOpen: false })
  }

  handleOutsideClick = () => {
    if (!this.state.overInput) {
      this.setState({ showOverlay: false, datepickerOpen: false })
    }
  }

  handleInputFocus = () => {
    if (this.state.q.length > 0) {
      if (isMobile && !this.state.showOverlay) {
        // scroll to top to fix the input field in the overlay being out of view on iphone
        window.scrollTo(0, 0)
        this.setZIndexOfNotificationBanner(0)
      }
      this.setState({ showOverlay: true }, () => {
        if (isMobile) {
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = "none"
          }
        }
      })
    }
  }

  setZIndexOfNotificationBanner = (zindex) => {
    const notificationBanner = document.querySelector(".notification")
    if (notificationBanner) {
      const notificationVersion = notificationBanner.dataset.notificationVersion
      const notificationCookie = cookieHelper.getCookie(notificationVersion)
      if (notificationCookie !== "closed") {
        notificationBanner.style.zIndex = zindex
      }
    }
  }

  render() {
    const icon = SelectionFactoryHelper.getFromSelectionFactory(this.props.icon)

    // contact
    const phoneIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.phoneIcon)
    const websiteIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.websiteIcon)
    const websiteTarget = SelectionFactoryHelper.getFromSelectionFactory(this.props.websiteLink.linkTarget)

    // check-in
    const checkinInTerminalIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.checkinInTerminalIcon)

    const handlingCompanyIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.handlingCompanyIcon)
    const handlingCompanyTarget = SelectionFactoryHelper.getFromSelectionFactory(this.props.handlingCompanyPageUrl.linkTarget)

    const checkinOptionsIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.checkinOptionsIcon)
    const websiteCheckinTarget = SelectionFactoryHelper.getFromSelectionFactory(this.props.websiteCheckInLink.linkTarget)
    const mobileCheckinTarget = SelectionFactoryHelper.getFromSelectionFactory(this.props.mobileCheckInLink.linkTarget)

    // luggage
    const lostLuggageIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.lostLuggageIcon)
    const lostLuggageTarget = SelectionFactoryHelper.getFromSelectionFactory(this.props.lostLuggageLink.linkTarget)
    const otherLuggageIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.otherLuggageIcon)

    // security
    const cphExpressIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.cphExpressIcon)
    const sasFastTrackIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.sasFastTrackIcon)

    return (
      <React.Fragment>
        <div className="flight-search-hero-container flight-search-hero-container--simple flight-search-hero-container--simple--airline">
          <section className={`deck deck--front`}>
            <header className="section-header section-header-search">
              <div className="section-header__inner">
                <div className="w--normal">
                  <div className="leftside">
                    <img src={this.props.airlineLogo} loading="eager" fetchPriority="high" />
                    <h1>
                      <strong>{isMobile ? this.props.airlineNameMobile : this.props.airlineName}</strong>
                      <br />
                      <span>{this.props.iataCodes.join(", ")}</span>
                    </h1>
                    <div className="maintext"></div>
                  </div>
                  <div className="flight-searchbox">
                    <div className="headline">
                      {this.props.iconUpload ? (
                        <img src={this.props.iconUpload} alt={"icon"} />
                      ) : icon ? (
                        <Svg iconName={icon} fillColor={"#060e4d"} />
                      ) : (
                        ""
                      )}
                      <span>{this.props.searchBoxTitle}</span>
                    </div>
                    <div className="form">
                      <div className="form__section form__section--light form__section--fat">
                        <div className={`form__section__inner ${isMobile && this.state.showOverlay ? "is-active" : ""}`}>
                          <div className="form__field form__field--text form__field--text-search form__field--text--no-label is-bound is-filled">
                            <span className="form__valid"></span>
                            <input
                              className="form__item"
                              id="flight-search-hero-input"
                              autoComplete="off"
                              autoCapitalize="none"
                              name="q"
                              type="text"
                              placeholder={this.props.searchBoxPlaceholder}
                              value={this.state.q}
                              onChange={(e) => this.handleInput(e)}
                              onMouseEnter={() => this.setState({ overInput: true })}
                              onMouseLeave={() => this.setState({ overInput: false })}
                              onFocus={() => this.handleInputFocus()}
                            />
                            {!isMobile ? (
                              <button
                                className={`search-button ${this.state.showOverlay ? "active" : ""}`}
                                onClick={this.state.showOverlay ? this.handleCloseOverlay : undefined}
                              >
                                <div className={`search-icon`}></div>
                              </button>
                            ) : (
                              ""
                            )}
                            {isMobile && this.state.showOverlay ? (
                              <button onClick={this.handleCloseOverlay}>
                                <Svg iconName={"close"} fillColor={"#060e4d"} />
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                          <OutsideClickTrigger onOutsideClick={() => (isMobile ? undefined : this.handleOutsideClick())}>
                            <SearchOverlay
                              {...this.props}
                              {...this.state}
                              handleDirectionChange={this.handleDirectionChange}
                              handleDateChange={this.handleDateChange}
                              locale={this.props.locale === "da" ? da : enGB}
                              handleDatepicker={this.handleDatepicker}
                              closeDatepicker={this.closeDatepicker}
                              showTime={isMobile ? false : true}
                            />
                          </OutsideClickTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clear"></div>
              </div>
            </header>
          </section>
        </div>
        <div className="airlinepage">
          <h2>{`${this.props.contactHeadline} ${isMobile ? this.props.airlineNameMobile : this.props.airlineName}`}</h2>
          <div className="contactinfo infobox">
            {this.props.phoneNumber ? (
              <a href={`Tel:${this.props.phoneNumber}`} className="phone">
                {this.props.phoneIconUpload ? (
                  <span className="icon">
                    <img src={this.props.phoneIconUpload} alt={"phone icon"} />
                  </span>
                ) : phoneIcon ? (
                  <Svg iconName={phoneIcon} />
                ) : (
                  ""
                )}
                <div className="textinfo">
                  <div className="headline">{this.props.phoneNumberLabel || "Telefonnummer"}</div>
                  <div className="link">{this.props.phoneNumber}</div>
                </div>
              </a>
            ) : (
              <div className="phone no-link">
                {this.props.phoneIconUpload ? (
                  <span className="icon">
                    <img src={this.props.phoneIconUpload} alt={"phone icon"} />
                  </span>
                ) : phoneIcon ? (
                  <Svg iconName={phoneIcon} />
                ) : (
                  ""
                )}
                <div className="textinfo">
                  <div className="headline">{this.props.phoneNumberLabel || "Telefonnummer"}</div>
                  <div className="link">{this.props.phoneNumberFallbackText}</div>
                </div>
              </div>
            )}

            <a
              href={this.props.websiteLink.linkUrl}
              target={websiteTarget}
              onClick={() => handleClickTracking(this.props.websiteLink.linkTracking)}
              className="website"
            >
              {this.props.websiteIconUpload ? (
                <span className="icon">
                  <img src={this.props.websiteIconUpload} alt={"website icon"} />
                </span>
              ) : websiteIcon ? (
                <Svg iconName={websiteIcon} />
              ) : (
                ""
              )}
              <div className="textinfo">
                <div className="headline">{this.props.website || "Website"}</div>
                <div className="link">{this.props.websiteLink.linkText}</div>
              </div>
            </a>
          </div>
          <div className="extrainfocontainer">
            <div className="checkininfo infobox">
              <h2>{this.props.checkinIformationHeadline || "Check-in information"}</h2>
              <div className="boxonmobile">
                <div className="link">
                  {this.props.checkinInTerminalIconUpload ? (
                    <span className="icon">
                      <img src={this.props.checkinInTerminalIconUpload} alt={"check-in terminal icon"} />
                    </span>
                  ) : checkinInTerminalIcon ? (
                    <Svg iconName={checkinInTerminalIcon} />
                  ) : (
                    ""
                  )}
                  <div className="textinfo">
                    <div className="headline">{`${this.props.checkinInTerminal || "Check-in terminal"}`}</div>
                    <div>{this.props.terminalCheckIn}</div>
                  </div>
                </div>
                <div className="link">
                  {this.props.handlingCompanyIconUpload ? (
                    <span className="icon">
                      <img src={this.props.handlingCompanyIconUpload} alt={"handling company icon"} />
                    </span>
                  ) : handlingCompanyIcon ? (
                    <Svg iconName={handlingCompanyIcon} />
                  ) : (
                    ""
                  )}
                  <div className="textinfo">
                    <div className="headline">{this.props.handlingCompanyLabel || "Handlingselskab"}</div>
                    <a
                      href={`${this.props.handlingCompanyPageUrl.linkUrl}#${this.props.handlingCompany}`}
                      target={handlingCompanyTarget}
                      onClick={() => handleClickTracking(this.props.handlingCompanyPageUrl.linkTracking)}
                    >
                      {this.props.handlingCompany}
                    </a>
                  </div>
                </div>
                <div className="link">
                  {this.props.checkinOptionsIconUpload ? (
                    <span className="icon">
                      <img src={this.props.checkinOptionsIconUpload} alt={"check-in options icon"} />
                    </span>
                  ) : checkinOptionsIcon ? (
                    <Svg iconName={checkinOptionsIcon} />
                  ) : (
                    ""
                  )}
                  <div className="textinfo">
                    <div className="headline">{`${this.props.checkinOptions} ${
                      isMobile ? this.props.airlineNameMobile : this.props.airlineName
                    }`}</div>
                    {/* hide if no link */}
                    {this.props.mobileCheckIn && this.props.mobileCheckInLink.linkUrl ? (
                      <a
                        href={this.props.mobileCheckInLink.linkUrl}
                        target={mobileCheckinTarget}
                        onClick={() => handleClickTracking(this.props.mobileCheckInLink.linkTracking)}
                      >
                        {this.props.checkInMobile}
                      </a>
                    ) : (
                      ""
                    )}
                    {this.props.websiteCheckIn && this.props.websiteCheckInLink.linkUrl ? (
                      <a
                        href={this.props.websiteCheckInLink.linkUrl}
                        target={websiteCheckinTarget}
                        onClick={() => handleClickTracking(this.props.websiteCheckInLink.linkTracking)}
                      >
                        {this.props.checkinHomepage}
                      </a>
                    ) : (
                      ""
                    )}
                    {/* posibility for link, but always show label */}
                    {this.props.selfCheckIn && this.props.selfCheckinLink ? (
                      <a href={this.props.selfCheckinLink} onClick={() => handleClickTracking(this.props.selfCheckinLinkTracking)}>
                        {this.props.selfCheckinLabel}
                      </a>
                    ) : this.props.selfCheckIn ? (
                      <div>{this.props.selfCheckinLabel}</div>
                    ) : (
                      ""
                    )}
                    {/* if no check-in options chosen, show fallback text */}
                    {!(this.props.mobileCheckIn && this.props.mobileCheckInLink.linkUrl) &&
                    !(this.props.websiteCheckIn && this.props.websiteCheckInLink.linkUrl) &&
                    !(this.props.selfCheckIn && this.props.selfCheckinLink) ? (
                      <div>{this.props.checkinOptionsFallback || "Check-in i lufthavnen"}</div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="luggageinfo infobox">
              <h2>{this.props.luggageInformationHeadline || "Bagage information"}</h2>
              <div className="boxonmobile">
                <div className="link">
                  {this.props.lostLuggageIconUpload ? (
                    <span className="icon">
                      <img src={this.props.lostLuggageIconUpload} alt={"lost luggage icon"} />
                    </span>
                  ) : lostLuggageIcon ? (
                    <Svg iconName={lostLuggageIcon} />
                  ) : (
                    ""
                  )}
                  <div className="textinfo">
                    <div className="headline">{this.props.lostLuggage || "Mistet bagage"}</div>
                    <a
                      href={this.props.lostLuggageLink.linkUrl}
                      target={lostLuggageTarget}
                      onClick={() => handleClickTracking(this.props.lostLuggageLink.linkTracking)}
                    >
                      {this.props.lostLuggageLink.linkText}
                    </a>
                  </div>
                </div>
                {this.props.otherLuggage && this.props.otherLuggageInfoText ? (
                  <div className="link">
                    {this.props.otherLuggageIconUpload ? (
                      <span className="icon">
                        <img src={this.props.otherLuggageIconUpload} alt={"other luggage icon"} />
                      </span>
                    ) : otherLuggageIcon ? (
                      <Svg iconName={otherLuggageIcon} />
                    ) : (
                      ""
                    )}
                    <div className="textinfo">
                      <div className="headline">{this.props.otherLuggage}</div>
                      <div className="rich">{ReactHtmlParser(this.props.otherLuggageInfoText)}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {this.props.expressCheckIn || this.props.sasFastTrack ? <h2>{this.props.SecurityIformationHeadline || "Security information"}</h2> : ""}
              {this.props.expressCheckIn ? (
                <React.Fragment>
                  <div className="boxonmobile">
                    <div className="link">
                      {this.props.cphExpressIconUpload ? (
                        <span className="icon">
                          <img src={this.props.cphExpressIconUpload} alt={"cph express icon"} />
                        </span>
                      ) : cphExpressIcon ? (
                        <Svg iconName={cphExpressIcon} />
                      ) : (
                        ""
                      )}
                      <div className="textinfo">
                        <div className="headline">{this.props.cphExpressSubTitle}</div>
                        {this.props.cphExpressLink ? (
                          <a href={this.props.cphExpressLink} onClick={() => handleClickTracking(this.props.cphExpressLinkTracking)}>
                            {this.props.cphExpress}
                          </a>
                        ) : (
                          <div>{this.props.cphExpress}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
              {this.props.sasFastTrack ? (
                <React.Fragment>
                  <div className="boxonmobile">
                    <div className="link">
                      {this.props.sasFastTrackIconUpload ? (
                        <span className="icon">
                          <img src={this.props.sasFastTrackIconUpload} alt={"cph express icon"} />
                        </span>
                      ) : sasFastTrackIcon ? (
                        <Svg iconName={sasFastTrackIcon} />
                      ) : (
                        ""
                      )}
                      <div className="textinfo">
                        <div className="headline">{this.props.sasFastTrackSubTitle}</div>
                        {this.props.sasFastTrackLink ? (
                          <a href={this.props.sasFastTrackLink} onClick={() => handleClickTracking(this.props.sasFastTrackLinkTracking)}>
                            {this.props.fastTrack}
                          </a>
                        ) : (
                          <div>{this.props.fastTrack}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
            <div className="clear"></div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
